export const LOGIN_USER = "coinshift/login/LOGIN_USER";
export const LOGIN_USER_SUCCESS = "coinshift/login/LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "coinshift/login/LOGIN_USER_ERROR";

export const IMPORT_SAFE = "coinshift/login/IMPORT_SAFE";
